import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "../pages/home/page";
import Topics from "../pages/topics/page";
import TopicDetail from "../pages/topic/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "topics",
        element: <Topics />,
      },
      {
        path: "topic/:id",
        element: <TopicDetail />,
      },
      {
        path: "about",
        element: <About />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;